export default "__VITE_ASSET__BeYsQ$9a__"